'use client';

import { AttributionCapture } from '@/components/analytics/attribution-capture';
import { ConsentProvider } from '@/components/consent/consent-context';
import { TrackingScripts } from '@/components/consent/tracking-scripts';
import { CookieConsent } from '@/components/cookie-consent';
import { GiftCardModalProvider } from '@/components/gift-card-modal';

export function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <ConsentProvider>
      <GiftCardModalProvider>
        {children}
        <CookieConsent />
        <TrackingScripts />
        <AttributionCapture />
      </GiftCardModalProvider>
    </ConsentProvider>
  );
}
